import { Store } from '@ngrx/store';
import { IWindowService } from 'angular';
import { IStateService } from 'angular-ui-router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { USER_ROLE_PERMISSIONS_FOR_STATES } from '../../../ng2/shared/constants/user-role-permissions-for-states.constant';
import { PATH_TYPE } from '../../../ng2/shared/services/api-service/api-service';
import { ISchool } from '../../../ng2/shared/typings/interfaces/school.interface';
import {
  getCollegePathEntities,
  getCollegePathLoadedStatus,
  getDataLoadsEntities,
  getDataLoadsLoadedStatus,
  getMyStudentsList,
  getMyStudentsLoadedStatus,
  LoadCollegePath,
  LoadDataLoads,
  LoadMyStudents,
} from '../../../ng2/store';
import { SpinnerModal } from '../../shared/modals/status-spinner/status-spinner.service';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';

angular.module('nv.routes.main').config($stateProvider => {
  /* istanbul ignore next */
  $stateProvider
    .state('main.school.data-uploads', {
      abstract: true,
      url: '/data-uploads',
      template: '<div ui-view></div>',
      data: {},
      onExit: ($window: IWindowService) => {
        $window.document.title = 'Data Portal';
      },
      resolve: {
        students$: [
          'StudentsResolver',
          'currentSchool',
          'Store',
          (StudentsResolver, currentSchool, Store) =>
            StudentsResolver.resolveAllStudentsList$(
              {
                studentLoadAction: LoadMyStudents,
                loadedStatusSelector: getMyStudentsLoadedStatus,
                studentSelector: getMyStudentsList,
              },
              currentSchool,
              Store,
            ),
        ],
        studentPaths$: [
          'currentSchool',
          'Store',
          'StudentPathsResolver',
          (currentSchool: ISchool, Store: Store<any>, StudentPathsResolver: { resolveStudentPaths$: Function }) =>
            StudentPathsResolver.resolveStudentPaths$(currentSchool, Store),
        ],
        collegePaths$: [
          'Store',
          'currentSchool',
          (Store, currentSchool) => {
            const payload = { schoolId: currentSchool._id, pathType: PATH_TYPE.COLLEGE };
            const collegePathLoaded = getCollegePathLoadedStatus;
            const destroy$: Subject<boolean> = new Subject<boolean>();

            return new Promise(resolve => {
              Store.select(collegePathLoaded)
                .pipe(takeUntil(destroy$))
                .subscribe(loaded => {
                  if (!loaded) {
                    Store.dispatch(new LoadCollegePath(payload));
                  } else {
                    const paths$ = Store.select(getCollegePathEntities);
                    destroy$.next(true);
                    destroy$.unsubscribe();
                    resolve(paths$);
                  }
                });
            });
          },
        ],
        dataLoads$: [
          'Store',
          'currentSchool',
          (Store, currentSchool) => {
            const payload = { schoolId: currentSchool._id };
            const dataLoadsLoaded = getDataLoadsLoadedStatus;
            const destroy$: Subject<boolean> = new Subject<boolean>();

            return new Promise(resolve => {
              Store.select(dataLoadsLoaded)
                .pipe(takeUntil(destroy$))
                .subscribe(loaded => {
                  if (!loaded) {
                    Store.dispatch(new LoadDataLoads(payload));
                  } else {
                    const dataLoads$ = Store.select(getDataLoadsEntities);
                    destroy$.next(true);
                    destroy$.unsubscribe();
                    resolve(dataLoads$);
                  }
                });
            });
          },
        ],
      },
    })

    .state('main.school.data-uploads.college-list', {
      abstract: false,
      url: '/college-list',
      resolve: {
        currentRoute: () => {
          return 'College list';
        },
      },
      template: `
        <nv-data-uploads
          [current-user]="$resolve.currentUser"
          [current-route]="$resolve.currentRoute"
          [current-school]="$resolve.currentSchool"
          [student-paths$]="$resolve.studentPaths$"
          [college-paths$]="$resolve.collegePaths$"
          [students$]="$resolve.students$"
          [data-loads$]="$resolve.dataLoads$"
        ></nv-data-uploads>
      `,
      data: {
        roles: USER_ROLE_PERMISSIONS_FOR_STATES['main.school.data-uploads.college-list'],
      },
      onEnter: (
        SpinnerModal: SpinnerModal,
        $state: IStateService,
        $window: angular.IWindowService,
        ImSchool: ImSchool,
        currentSchool: ISchool,
      ) => {
        $state.transition.then(() => {
          const isHS = ImSchool.isHighSchool(currentSchool);
          if (!isHS) $state.go('main.home');
        });
        SpinnerModal.deactivateSpinner();
        $window.document.title = 'Data Entry - Data Uploads | Data Portal';
      },
    })

    .state('main.school.data-uploads.gradebook', {
      abstract: false,
      url: '/gradebook',
      resolve: {
        currentRoute: () => {
          return 'Gradebook';
        },
      },
      template: `
        <nv-data-uploads
          [current-user]="$resolve.currentUser"
          [current-route]="$resolve.currentRoute"
          [current-school]="$resolve.currentSchool"
          [student-paths$]="$resolve.studentPaths$"
          [college-paths$]="$resolve.collegePaths$"
          [students$]="$resolve.students$"
          [data-loads$]="$resolve.dataLoads$"
        ></nv-data-uploads>
      `,
      data: {
        roles: USER_ROLE_PERMISSIONS_FOR_STATES['main.school.data-uploads.gradebook'],
      },
      onEnter: (
        SpinnerModal: SpinnerModal,
        $window: angular.IWindowService,
        $state: IStateService,
        ImSchool: ImSchool,
        currentSchool: ISchool,
      ) => {
        $state.transition.then(() => {
          const isHS = ImSchool.isHighSchool(currentSchool);
          if (!isHS) $state.go('main.home');
        });
        SpinnerModal.deactivateSpinner();
        $window.document.title = 'Data Entry - Data Uploads | Data Portal';
      },
    });
});
